import { ComputedRef, type Ref, computed, ref } from 'vue';

export function useLoading<K extends Exclude<string, 'startLoading' | 'stopLoading'>>(
	keys: K[]
): Record<K, ComputedRef<boolean>> & {
	startLoading: (key: (typeof keys)[number]) => void;
	stopLoading: (key: (typeof keys)[number]) => void;
} {
	const _loadingFlags = {} as Record<K, Ref<boolean>>;
	const loadingFlags = {} as Record<K, ComputedRef<boolean>>;

	keys?.map(key => {
		_loadingFlags[key] = ref(false);
		loadingFlags[key] = computed(() => _loadingFlags[key].value);
	});

	const startLoading = (key: (typeof keys)[number]) => {
		_loadingFlags[key].value = true;
	};

	const stopLoading = (key: (typeof keys)[number]) => {
		_loadingFlags[key].value = false;
	};

	return {
		/** Refs and computed */
		...loadingFlags,

		/** Functions */
		startLoading,
		stopLoading
	};
}
